import axios from "axios";

export const API = "/api";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("lsk_admin_token");
  const customerToken = localStorage.getItem("lsk_customer_token");
  if (adminToken && config.url?.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  } else if (customerToken) {
    config.headers.Authorization = `Bearer ${customerToken}`;
  }
  return config;
});
